import { Pressable, PressableProps, StyleSheet } from 'react-native';
import { useBoolean } from 'usehooks-ts';

import { Text } from '@pletly/ui';

interface Props extends PressableProps {
	text?: string | null;
}

export const PressableCell = ({ text, onPress, ...pressableProps }: Props) => {
	const { value: isHovered, setTrue: setHovered, setFalse: setUnHovered } = useBoolean();

	return (
		<Pressable
			style={styles.root}
			onHoverIn={setHovered}
			onHoverOut={setUnHovered}
			onPress={onPress}
			{...pressableProps}
		>
			<Text
				category="p1"
				style={onPress && isHovered ? styles.underlined : undefined}
				numberOfLines={1}
			>
				{text ?? ''}
			</Text>
		</Pressable>
	);
};

const styles = StyleSheet.create({
	root: {
		flex: 1,
	},
	underlined: {
		textDecorationLine: 'underline',
	},
});
